<template>
  <div v-if="poh">
    <van-popup v-model="visible" position="bottom" :style="{ height: 'auto', width: '100%' }">
      <van-nav-bar title="訂單明細 Order Detail" placeholder>
        <template #left>
          <div class="C2" @click="close()">
            <van-icon name="arrow-left" :color="sGetConfig('color2')" />
          </div>
        </template>
      </van-nav-bar>

      <!-- <van-grid column-num="1">
        <van-grid-item>
          <div class="tip">{{ poh }}</div>
        </van-grid-item>
      </van-grid> -->

      <div class="main">
        <!-- {{ poh }}
        {{ poh.ShipTime }} -->
        <!-- <van-row>
        <van-col span="12"
          ><i class="el-icon-s-order" />{{ orderh.TblName }}</van-col
        >
        <van-col span="12" align="right">
          <i class="el-icon-s-custom" />{{ orderh.CustTotal }}
        </van-col>
      </van-row> -->
        <!-- {{ poh.OrderNo }} -->
          
      
        <!-- <div style="text-align: center;" v-if="sGetConfig('chkPoIQrcode')">
          <vue-qr :text="poh.OrderNo" :size="200"></vue-qr>
          <br />
          請出示條碼供櫃檯結帳
          <van-divider />
        </div> -->

        <van-row v-for="r in sPoI.filter((r) => r.OrderNo == poh.OrderNo)" :key="r.rno">
          <van-col span="17">
            {{ r.ItemName }}
            <span class="note" v-if="r.Remark"> {{ r.Remark }}</span>
            <!-- <span v-if="isS1(oi)">{{ oi.ItemName }} </span>
                <span v-else class="s2">{{ oi.ItemName }} </span>
                <span class="note" v-if="oi.Remark"> {{ oi.Remark }}</span> -->
          </van-col>

          <van-col span="2">x<span class="C1">{{ r.Qty }}</span></van-col>
          <van-col span="5" align="right">
            <span v-if="r.Amt < 0" class="C4">{{ r.Amt }}</span>
            <span v-if="r.Amt >= 0" class="C1">{{ r.Amt }}</span>
            元
          </van-col>
        </van-row>
        <van-divider />
        共<span class="C1"> {{ getSum(poh).qty }} </span>項
        <van-divider />
        <van-row>
          <van-col span="12">小計 Sub Total</van-col>
          <van-col span="12" align="right">
            <span class="C1">{{ getSum(poh).amt }}</span> 元
          </van-col>
          <van-col span="12">服務費 Service</van-col>
          <van-col span="12" align="right">
            <span class="C1">{{ getSum(poh).service }}</span> 元
          </van-col>
          <van-col span="12">合計 Service</van-col>
          <van-col span="12" align="right">
            <span class="C1">{{ getSum(poh).total }}</span> 元
          </van-col>
        </van-row>
        <!-- <div class="footer">
          <van-divider />

          <van-divider />
          <van-row>
            <van-col span="12">合計 Grand Total</van-col>
            <van-col span="12" align="right"
              ><span class="C1">{{ gSum(orderi, "Amt") + serviceAmt() }}</span
              >元</van-col
            >
          </van-row>
          <div style="height: 10rem" /> -->
      </div>
      <!-- <Footer b1="返回 Back" @b1c="close()" anime /> -->
    </van-popup>
  </div>
</template>

<style scoped>
.van-cell {
  color: v-bind(sGetConfig("color2"));
}

.tip {
  color: grey;
}

.van-row {
  line-height: 1.8rem;
}

/* .s1 {
  color: black;
  font-size: 1rem;
} */
.s2 {
  color: grey;
  /* font-weight: bold; */
  /* font-size: 1rem; */
}

.van-popup {
  width: 100%;
  /* min-height: 100vh; */
}

.main {
  padding: 1rem;
  line-height: 1.6rem;
  font-size: 1rem;
  /* overflow: scroll; */
  /* height: 100%; */
}
</style>
<script>
export default {
  data() {
    return {
      visible: false,
      poh: null,
    };
  },
  methods: {
    show(poh) {
      this.poh = poh;
      this.visible = true;
    },
    cmdServiceType() {
      this.visible = false;
      this.$refs.rServiceType.show();
    },
    cmdWelcome() {
      this.visible = false;
      this.$refs.rWelcome.show();
    },
    cmdOCheck() {
      this.visible = false;
      this.$refs.rOCheck.showAndLoad();
    },
    getSum(poh) {
      var poi = this.sPoI.filter((r) => r.OrderNo == poh.OrderNo);
      var sum = {};
      sum.amt = this.gSum(poi, "Amt");
      sum.qty = this.gSum(poi, "Qty");
      sum.service = 0;
      sum.total = sum.amt + sum.service;
      return sum;
    },
    close() {
      this.visible = false;
      this.$emit("close");
    },
  },
};
</script>
